module.exports = __webpack_public_path__ + "img/icon-plus.ab6d22fa.svg";